<template>
  <div id="wrapper">
    <div class="modal-content">
    <div class="pdfviewer">
        <div class="pdfjs-toolbar text-center" id="toolbar">
          <div class="col-12 col-sm-6">
            <button @click="pagePr" data-testid="previous-btn"
            class="btn btn-secondary btn-sm btn-prev" id="page-previous">
            <font-awesome-icon icon="angle-left"/></button>
            <span class="pageno"></span>
            <button @click="pageNxt" data-testid="next-btn"
            class="btn btn-secondary btn-sm btn-next" id="page-next">
            <font-awesome-icon icon="angle-right"/></button>
          </div>
          <div class="col-12 col-sm-6">
            <button @click="pageZo" class="btn btn-secondary btn-sm" id="page-zoom-out">
            <font-awesome-icon icon="search-minus"/></button>
            <span class="zoomval"></span>
            <button @click="pageZi" class="btn btn-secondary btn-sm" id="page-zoom-in">
            <font-awesome-icon icon="search-plus"/></button>
            <button @click="pageZf" class="btn btn-secondary btn-sm" id="page-zoom-fit">
            <font-awesome-icon icon="compress"/></button>
          </div>
        </div>
        <div class="pdfjs-viewer" id="preview-file" data-testid="pdfjs-viewer"></div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import pdfjsWorker from 'pdfjs-worker';
import { PDFjsViewer } from '@/assets/js/pdfjs-viewer.js';

window.pdfjsLib = require('pdfjs-dist');
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default {
  data() {
    return {
      preview_url: null,
      pdfViewer: null,
      file: {
        isimage: false,
      },
    };
  },
  mounted() {
    this.pdfViewer = new window.PDFjsViewer($(".pdfjs-viewer"),  {
        onZoomChange: function (zoom) {
            zoom = parseInt(zoom * 10000) / 100;
            $(".zoomval").text(zoom + "%");
        },
        onActivePageChanged: function (page, pageno) {
            $(".pageno").text(pageno + "/" + this.getPageCount());
        }
    })
  },
  methods: { 
    pagePr() {
      this.pdfViewer.prev();
    },
    pageNxt() {
      this.pdfViewer.next();
    },
    pageZo() {
      this.pdfViewer.setZoom('out');
    },
    pageZf() {
      this.pdfViewer.setZoom('fit');
    },
    pageZi() {
      this.pdfViewer.setZoom('in');
    },
    loadPdf() {
      $('#preview-file').height($(document).height() - 260);
      this.pdfViewer.loadDocument(this.preview_url) 
      .then(() => {
          this.pdfViewer.setZoom("fit");
      }).catch((error) => {
          // console.error(error)
          // modalError(gettext('Preview Error'), error.message);
      })
    },
    generateURL() {
      const pages = this.file.isImage ? 1 : 0;
      this.preview_url = `${this.url}&format=pdf&pages=${pages}`;
      this.loadPdf();
    },
    setMaxPage() {
      this.maxPage = this.page;
    },
    loadfile(url, file) {
      this.page = 1;
      this.url = url;
      this.file = file;
      this.generateURL();
    },
  },
};
</script>

<style scoped>
#wrapper {
  width: 100%;
  height: 75vh;
}
.modal-content {
  border: none;
}
button {
  color: #777;
  border: none;
  margin-right: 10px;
}
.btn:disabled:hover {
  color: gray;
}
</style>
